import React from 'react'
import { Button, ButtonProps, IconX, csx } from '@vtex/admin-ui'
import { useBottomSliderModalContext } from './BottomSliderModalProvider'
import classNames from 'classnames'

export const BottomSliderModalCloseButton = ({
  className,
  ...props
}: ButtonProps) => {
  const { onClose = () => {} } = useBottomSliderModalContext()

  return (
    <Button
      icon={<IconX title="Close" />}
      aria-label="Close Bottom Slider Modal"
      variant="neutralTertiary"
      onClick={onClose}
      className={classNames(
        csx({
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 1,
        }),
        className
      )}
      {...props}
    />
  )
}
